import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-task-management-dialog",
    templateUrl: "./task-management-dialog.component.html",
    styleUrls: ["./task-management-dialog.component.scss"],
    standalone: false
})
export class TaskManagementDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TaskManagementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public taskMgmtDetails: any
  ) {}

  onSaved(result: any): void {
    this.dialogRef.close(result);
  }

  onCancelled(): void {
    this.dialogRef.close();
  }
}
